import React, { useState, useEffect, useRef } from 'react';
import { registerBrick, File as OFile, Transaction } from 'olympe';
import { ReactBrick, dataUrlToBinary } from '@olympeio/core';
import TuiImageEditor from 'tui-image-editor';
import '../../../../res/stylesheets/editorPicture.scss';

const ImageEditor = (props) => {
    const rootEl = useRef();
    let imageEditorInst;

    useEffect(() => {
        imageEditorInst = new TuiImageEditor(rootEl.current, {
            ...props,
        });

        // Hack for typing text
        setTimeout(() => {
            const textareaContainer = rootEl.current;
            const graphics = imageEditorInst._graphics;
            const canvas = graphics._canvas;
            const { onObjectAdded } = graphics._handler;
            canvas.off('object:added', onObjectAdded);
            canvas.on('object:added', (event) => {
            const { target } = event;
            if (target.type === 'i-text') {
                target.hiddenTextareaContainer = textareaContainer;
            }
            onObjectAdded(event);
            });
        }, 100);

        return () => {
            imageEditorInst.destroy();
            imageEditorInst = null;
        };
    }, []);

    const handleClickButton = () => {
        const editedFileContent = imageEditorInst.toDataURL();
        props.onSaveFile(editedFileContent);
    };

    return (
        <>
            <div ref={rootEl} />
            <button
                className='save-button'
                onClick={handleClickButton}>
                Save
            </button>
        </>
    );
};

export default class EditionPicture extends ReactBrick {

    /**
     * @override
     */
    setupExecution($) {
        return $.observe('File');
    }

    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {
            const [selectedFile, setSelectedFile] = useState();
            const [fileName, setFileName] = useState('');
            const [mimeType, setMimeType] = useState('');
            const file = props.values[0];

            // white theme
            const whiteTheme = {
                'common.backgroundColor': '#fff',
                'submenu.iconSize.width': '16px',
                'menu.iconSize.width': '16px',
            };

            useEffect(() => {
                file.getContentUrl().then((content) => {
                    setFileName(file.get(OFile.fileNameProp));
                    setMimeType(file.get(OFile.mimeTypeProp));
                    setSelectedFile(content);
                });
            }, []);

            const saveFile = (fileContent) => {
                const transaction = new Transaction();
            
                OFile.setContent(
                    transaction,
                    file.getTag(),
                    fileName,
                    dataUrlToBinary(fileContent),
                    mimeType
                );
                transaction.execute().then(() => {
                    $.trigger('onFileSaved');
                });
            }

            const propsImageEditor = {
                includeUI: {
                    uiSize: {
                        width: '100%',
                        height: '100%',
                    },
                    loadImage: {
                         path: selectedFile,
                         name: fileName,
                    },
                    menu: ['shape', 'draw', 'icon', 'text'],
                    initMenu: 'draw',
                    theme: whiteTheme,
                    menuBarPosition: 'bottom',
                },
                usageStatistics: false,
            };

            return (
                <div className='container'>
                    {selectedFile && (
                        <ImageEditor
                            {...propsImageEditor}
                            onSaveFile={saveFile}
                        />
                    )}
                </div>
            );
        };
    }
}

registerBrick('0188fc1e84c808fa8345', EditionPicture);
